import { trigger } from '@angular/animations';
import { actionButton } from '@aws-amplify/ui';
import { Action, createReducer, on } from '@ngrx/store';
import * as GoalActions from './goal.actions';
import { Goal, GoalCategory } from './goal.models';

export const goalFeatureKey = 'goals';

export interface State {
  loadingGoals: boolean;
  loadingGoalError: string;
  userGoals: Goal[];

  loadingGoalCategories: boolean;
  loadingGoalCategoriesError: string;
  goalCategories: GoalCategory[];
}

export const initialState: State = {
  loadingGoals: false,
  loadingGoalError: null,
  userGoals: [],

  loadingGoalCategories: false,
  loadingGoalCategoriesError: null,
  goalCategories: []
};

export const reducer = createReducer(
  initialState,

  on(GoalActions.loadGoals, (state) => {
    return { ...state, loadingGoalError: null, loadingGoal: true };
  }),
  on(GoalActions.loadGoalsSuccess, (state, action) => {
    return {
      ...state,
      loadingGoal: false,
      userGoals: action.goals,
    };
  }),
  on(GoalActions.loadGoalsFailure, (state, action) => {
    return {
      ...state,
      loadingGoal: false,
      loadingGoalError: action.error,
    };
  }),
  on(GoalActions.loadGoalCategories, (state) => {
    return {
      ...state,
      loadingGoalCategories: true,
      loadingGoalCategoriesError: null,
    };
  }),
  on(GoalActions.loadGoalCategoriesSuccess, (state, action) => {
    return {
      ...state,
      loadingGoalCategories: false,
      goalCategories: action.goalCategories
    };
  }),
  on(GoalActions.loadGoalCategoriesFailure, (state, action) => {
    return {
      ...state,
      loadingGoalCategories: false,
      loadingGoalCategoriesError: action.error,
    };
  }),
  on(GoalActions.clearGoals, () => initialState)
);
